import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from '@angular/common/http';
import {LOCALE_ID, NgModule} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './shared/shared.module';
// // for HttpClient import:
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
// // for Router import:
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';
// // for Core import:
import { LoadingBarModule } from '@ngx-loading-bar/core';

import { CookieService } from 'ngx-cookie-service';

import { AppComponent } from './app.component';

import { OverlayModule } from '@angular/cdk/overlay';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {ErrorInterceptor} from './applications/interceptor/error.interceptor.service';
import {ToastrModule} from 'ngx-toastr';
import {DatePipe, NgOptimizedImage, registerLocaleData} from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import {MatButtonModule} from '@angular/material/button';
import {MatDialogModule} from '@angular/material/dialog';
import {NgStepperModule} from 'angular-ng-stepper';
import {CdkStepperModule} from '@angular/cdk/stepper';
import {Subject} from 'rxjs';
import {SplashScreenComponent} from './splash-screen/splash-screen.component';
import {MobileWarningComponent} from './applications/base/components/mobile-warning/mobile-warning.component';
import {DeviceChoiceModalComponent} from './device-choice-modal/device-choice-modal.component';
registerLocaleData(localeFr, 'fr');

// tslint:disable-next-line:typedef
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    SplashScreenComponent,



      // LoginComponent,

  ],
    imports: [
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        OverlayModule,
        SharedModule,
        AppRoutingModule,
        HttpClientModule,
        BrowserAnimationsModule,
        ToastrModule.forRoot(),
        NgbModule,
        MatDialogModule,
        MatButtonModule,
        CdkStepperModule,
        NgStepperModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            },
        }),

        // for HttpClient use:
        LoadingBarHttpClientModule,
        // for Router use:
        LoadingBarRouterModule,
        // for Core use:
        LoadingBarModule,
        BrowserAnimationsModule,
        NgOptimizedImage,
        MobileWarningComponent,
        DeviceChoiceModalComponent
    ],
  exports: [SplashScreenComponent] ,// Exportation pour une réutilisation éventuelle

  providers: [CookieService,DatePipe,Subject , provideAnimationsAsync(),
    { provide: HTTP_INTERCEPTORS,
    useClass: ErrorInterceptor, multi: true },
    { provide: LOCALE_ID, useValue: "fr-FR" }],
  bootstrap: [AppComponent]
}, )
export class AppModule { }
